export default __webpack_public_path__ + "static/media/on-site-survey.cee48309.png";